// extracted by mini-css-extract-plugin
module.exports = {"sectionWrap":"BranchInfoSectionShow__sectionWrap--C3yNo"};